import React, { CSSProperties, FC } from "react";
import { Icon as OfficeIcon } from "@fluentui/react";
import { FontSize, useTheme } from "cayo.ui";
import styled, { keyframes } from "styled-components";
import { IIcon } from "@cayo/shared/api/types/schema";
import GearIcon from "./../../images/gear.svg";
import MaskedIcon from "./MaskedIcon";

const Icon: FC<
  Omit<IIcon, "type"> & { rotateSpeed?: string | undefined; smallIconSize?: number } & {
    style?: CSSProperties;
    maskedIconStyle?: CSSProperties;
  }
> = (props) => {
  const { cayoTheme, resolveNamedColor } = useTheme();
  const icons = props.iconName?.split("+");
  const iconName = icons && icons[0];
  const maskedIconName = icons?.length && icons.length > 1 ? icons![1] : 0;
  const isGearedIcon = maskedIconName === "Gear";
  const unresolvedColor = props.style?.color || props.color;
  const defaultColor =
    (unresolvedColor && resolveNamedColor(unresolvedColor)) || cayoTheme.brandColors.disabled;

  const clipPathStyle: Partial<CSSProperties> = {};
  const maskedIconStyle = props.maskedIconStyle || {};

  if (maskedIconName) {
    clipPathStyle.clipPath = "polygon(100% 57%, 100% 0, 0 0, 0 100%, 49% 100%, 59% 87%, 74% 71%);";
  }

  const fontSize =
    props.style?.fontSize || (props.fontSize ? FontSizes[props.fontSize!] : undefined);

  const mainIcon = (
    <OfficeIcon
      iconName={iconName}
      color={defaultColor}
      styles={{
        root: {
          fontSize,
          //  fontWeight: props.style?.fontWeight as any,
          display: "flex",
          ...((props.style || {}) as any),
          ...clipPathStyle,
          color: defaultColor,
        },
      }}
    />
  );

  if (maskedIconName) {
    return (
      <MaskedIcon
        maskIcon={
          !isGearedIcon ? maskedIconName : <img alt="" src={GearIcon} width="9" height="8" />
        }
        maskPosition="rightBottom"
        color={props.style?.color ?? defaultColor}
        fontSize={props?.smallIconSize}
        style={{ ...maskedIconStyle }}
      >
        {isGearedIcon ? <GearedIcon isGearedIcon={isGearedIcon}>{mainIcon}</GearedIcon> : mainIcon}
      </MaskedIcon>
    );
  } else {
    let icon = mainIcon;
    if (props.rotate) {
      icon = (
        <Rotate speed={props.rotateSpeed} backward={props.backward}>
          {icon}
        </Rotate>
      );
    }

    return icon;
  }
};

const rotateForward = keyframes`
  from {
    transform: rotate(0deg); 
  }

  to {
    transform: rotate(360deg);
  }
`;

const rotateBackward = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
`;

const Rotate = styled.div<{ speed?: string | undefined; backward?: boolean | undefined }>`
  display: inline-block;
  animation: ${(props) => (props.backward ? rotateBackward : rotateForward)}
    ${(props) => props.speed || "2s"} linear infinite;
`;

const GearedIcon = styled.div<{ isGearedIcon: boolean }>`
  clip-path: ${(props) => props.isGearedIcon && "polygon(100% 0, 100% 42%, 40% 100%, 0 100%, 0 0)"};
`;

// TODO: move icon to UI kit and get sizes from the server theme
export const FontSizes: Record<FontSize, string> = {
  tiny: "10px",
  xSmall: "11px",
  small: "12px",
  smallPlus: "13px",
  medium: "14px",
  mediumPlus: "15px",
  large: "17px",
  xLarge: "21px",
  xxLarge: "28px",
  mega: "42px",
};

export default Icon;
